export default __webpack_public_path__ + "static/media/congrats_money.2e83add2.png";